import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { PageHeader } from "@/components";

import { useContactLeadPanelDeepLink } from "../hooks/useContactLeadPanelDeepLink";
import { ContactsTable } from "../components/ContactsTable";

export const ContactsView: FunctionComponent = () => {
	const { t } = useTranslation();

	// `?prospectId=<id>` deep link (extension "Open in Signalist") → auto-open the lead panel.
	useContactLeadPanelDeepLink();

	return (
		<div className="flex flex-col h-full w-full">
			<PageHeader title={t("contacts.title")} />
			<div className="w-full">
				<ContactsTable />
			</div>
		</div>
	);
};
